import type { ClientePerfil, MedidasCorporales } from '../../../../hooks/useAdminClientePerfil';
import ColorPaletteSection from './ColorPaletteSection';
import TonoPielSection from './TonoPielSection';
import OcasionesSection from './OcasionesSection';
import PrendasEvitarSection from './PrendasEvitarSection';
import EstiloNotasSection from './EstiloNotasSection';
import MedidasSection from './MedidasSection';
import CombinacionesSection from './CombinacionesSection';

interface Props {
  adminPerfil: ClientePerfil | null;
  paletteColors: string[];
  setPaletteColors: (v: string[] | ((prev: string[]) => string[])) => void;
  tonoPiel: string;
  setTonoPiel: (v: string) => void;
  estiloPersonal: string;
  setEstiloPersonal: (v: string) => void;
  notasEstilista: string;
  setNotasEstilista: (v: string) => void;
  ocasionesPreferidas: string[];
  setOcasionesPreferidas: (v: string[] | ((prev: string[]) => string[])) => void;
  prendasEvitar: string[];
  setPrendasEvitar: (v: string[] | ((prev: string[]) => string[])) => void;
  medidas: MedidasCorporales;
  setMedidas: React.Dispatch<React.SetStateAction<MedidasCorporales>>;
  combinacionesPersonalizadas: { base: string; complemento: string; tono: string; desc: string }[];
  setCombinacionesPersonalizadas: (v: { base: string; complemento: string; tono: string; desc: string }[] | ((prev: { base: string; complemento: string; tono: string; desc: string }[]) => { base: string; complemento: string; tono: string; desc: string }[])) => void;
  prendasQueCoincidenPaleta: { id: number | string; nombre: string; color: string }[];
}

export default function PerfilEditor(props: Props) {
  return (
    <div className="space-y-5">
      <ColorPaletteSection
        paletteColors={props.paletteColors}
        setPaletteColors={props.setPaletteColors}
      />
      <TonoPielSection tonoPiel={props.tonoPiel} setTonoPiel={props.setTonoPiel} />
      <OcasionesSection
        ocasionesPreferidas={props.ocasionesPreferidas}
        setOcasionesPreferidas={props.setOcasionesPreferidas}
      />
      <PrendasEvitarSection
        prendasEvitar={props.prendasEvitar}
        setPrendasEvitar={props.setPrendasEvitar}
      />
      <EstiloNotasSection
        estiloPersonal={props.estiloPersonal}
        setEstiloPersonal={props.setEstiloPersonal}
        notasEstilista={props.notasEstilista}
        setNotasEstilista={props.setNotasEstilista}
      />
      <MedidasSection medidas={props.medidas} setMedidas={props.setMedidas} />
      <CombinacionesSection
        paletteColors={props.paletteColors}
        combinacionesPersonalizadas={props.combinacionesPersonalizadas}
        setCombinacionesPersonalizadas={props.setCombinacionesPersonalizadas}
        prendasQueCoincidenPaleta={props.prendasQueCoincidenPaleta}
      />
    </div>
  );
}